import React from 'react';
import { formatMoney } from '../../utils/eventUtils';

// Reminds the group what is still owed to vendors, or still to be split, across its open events.
function PendingPaymentsPanel({ pending, currentUser, getName, onRecordPayment, onSplitItem }) {
  if (!pending || !pending.events || pending.events.length === 0) return null;

  const payerText = (userId) => (userId === currentUser.id ? 'You to pay' : `${getName(userId)} to pay`);

  return (
    <section className="dashboard-section card-box pending-payments-panel">
      <div className="container-header">
        <h3>⏳ Pending Payments</h3>
        <span className="count-badge pending-total">
          {Number(pending.totalOutstanding) > 0
            ? `${formatMoney(pending.totalOutstanding)} due`
            : `${formatMoney(pending.totalUnsplit)} to split`}
        </span>
      </div>

      <div className="pending-event-list">
        {pending.events.map((event) => {
          const myPending = event.pendingByMember.find((m) => m.userId === currentUser.id);
          // General payments are not tied to an item, so the per-item figures stop adding up
          // to what is really due; show the event as a single row in that case.
          const unpaidItems = event.items.filter((item) => Number(item.outstanding) > 0);
          const unsplitItems = event.items.filter((item) => Number(item.unallocated) > 0);
          const showItems = Number(event.generalPaid) === 0 && unpaidItems.length > 0;
          const rows = Number(event.outstanding) <= 0
            ? []
            : showItems
            ? unpaidItems.map((item) => ({
                key: item.itemId,
                itemId: item.itemId,
                name: item.itemName,
                outstanding: item.outstanding,
                total: item.total,
                expectedPayerId: item.expectedPayerId || event.expectedPayerId,
              }))
            : [
                {
                  key: event.eventId,
                  itemId: '',
                  name: 'Whole event',
                  outstanding: event.outstanding,
                  total: event.total,
                  expectedPayerId: event.expectedPayerId,
                },
              ];

          return (
            <div key={event.eventId} className="pending-event">
              <div className="pending-event-header">
                <span className="pending-event-name">{event.eventName}</span>
                {myPending && (
                  <span className="pending-my-share">Your pending share: {formatMoney(myPending.pending)}</span>
                )}
              </div>

              {rows.map((row) => (
                <div
                  key={row.key}
                  className={`pending-row ${row.expectedPayerId === currentUser.id ? 'mine' : ''}`}
                >
                  <span className="pending-row-name">{row.name}</span>
                  <span className="pending-row-amount">
                    <strong>{formatMoney(row.outstanding)}</strong> of {formatMoney(row.total)} due
                  </span>
                  {row.expectedPayerId && (
                    <span className="payer-badge">→ {payerText(row.expectedPayerId)}</span>
                  )}
                  <button className="btn-tiny" onClick={() => onRecordPayment(event.eventId, row.itemId)}>
                    Record payment
                  </button>
                </div>
              ))}

              {unsplitItems.map((item) => (
                <div key={`split-${item.itemId}`} className="pending-row">
                  <span className="pending-row-name">{item.itemName}</span>
                  <span className="pending-row-amount">
                    <strong>{formatMoney(item.unallocated)}</strong> of {formatMoney(item.total)} not yet split
                  </span>
                  <button className="btn-tiny" onClick={() => onSplitItem(event.eventId, item.itemId)}>
                    Split
                  </button>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default PendingPaymentsPanel;
